import script from "./ModalEditComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalEditComponent.vue?vue&type=script&setup=true&lang=js"

import "./ModalEditComponent.vue?vue&type=style&index=0&id=a9b6cf14&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9b6cf14"]])

export default __exports__